import { useContext } from 'react';
import { ThemeContext, ThemeContextValues } from '../ThemeProvider/ThemeContext';

export function useHoneycombTheme(): ThemeContextValues {
    return useContext(ThemeContext);
}
